export const data =[
    {
        id: "1",
        title: "Android App for Alzheimer's detection",
        desc: "An android application for early Alzheimer's detection and integrated care, using various quiz games to detect Alzheimer's and also provide care to patients in emergency.",
        link: "https://github.com/AdheenaBabu",
        img: "https://1z1euk35x7oy36s8we4dr6lo-wpengine.netdna-ssl.com/wp-content/uploads/2020/08/zymr8_steps_the_mobile_app_dev_lifecycle_cover.jpg"
    },
    {
        id: "2",
        title: "Vending machine simulator",
        desc: "This android application provides a simulation interface for Vending Machine, providing the user an experience of using a vending machine without actually using it.",
        link: "https://github.com/AdheenaBabu/VendingMachine",
        img: "https://fenzodigital.com/wp-content/uploads/2018/08/Mobile-App.png"
    },
    {
        id: "3",
        title: "Portfolio website",
        desc: "This is a fun personal project which you are seeing right now. This portfolio website was developed using react js. It is also the first project I did in react.",
        link: "https://github.com/AdheenaBabu",
        img: "https://buildfire.com/wp-content/uploads/2017/10/become-mobile-app-developer-1200x900.jpg"
    },
];